export class NomsHardman {


    public static readonly NOTREADY = "routeNotReady";
    public static readonly PROBLEM = "routeWithProblem";
    public static readonly DELAYED = "routeDelayed";
    public static readonly plateBanned: string = "plateBanned";
    public static readonly phoneBanned: string = "phoneBanned";

}